

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Grid, Button, Typography, Paper, CircularProgress } from '@mui/material';
import { deleteMessage, setMessages, markMessageHandled } from '../../features/contactSlice';
import { GetContcts, DeleteContct } from '../../utils/lookupUtil';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { useNavigate } from 'react-router-dom';

const MessagesList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const messages = useSelector(state => state.contact.messages);
  // console.log(messages);
  //const messages=[]
  const loadMessages = async () => {
    const data = await GetContcts();
    console.log(data);
    dispatch(setMessages(data));
  }

  useEffect(() => {
    loadMessages();
  }, [dispatch]);

  if (!messages) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" sx={{ p: 4 }}>
        <CircularProgress size={30} sx={{ mr: 5 }} />
        <Typography variant="h4" sx={{ mr: 5 }}>טוען הודעות</Typography>
      </Box>
    );
  }

  const handleDeleteMessage = async (id) => {
    try {
      const success = await DeleteContct(id); // true/false מהשרת

      if (success) {
        dispatch(deleteMessage(id)); // מעדכן את הסטור ומוריד מהטבלה
      } else {
        alert("ההודעה לא נמצאה");
      }
    } catch (err) {
      console.error(err);
      alert("שגיאה במחיקה");
    }
  };

  const formatDateIL = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);

  return d.toLocaleDateString("he-IL");
};





  return (
    <Box sx={{ flexGrow: 1, padding: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h4" gutterBottom>
            הודעות
          </Typography>
          <Paper sx={{ padding: 2 }}>
            <TableContainer component={Paper} sx={{ marginTop: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    {/* <TableCell>ID</TableCell> */}
                    <TableCell>שולח</TableCell>
                    <TableCell>אימייל</TableCell>
                    <TableCell>טלפון</TableCell>
                    <TableCell>תאריך</TableCell>
                    <TableCell>הודעה</TableCell>
                    <TableCell>פעולות</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {messages?.map((message) => (
                    <TableRow key={message.id}>
                      {/* <TableCell>{message.id}</TableCell> */}
                      <TableCell>{message.name}</TableCell>
                      <TableCell>{message.email}</TableCell>
                      <TableCell>{message.phone}</TableCell>
                      <TableCell>{formatDateIL(message.createdDate)}</TableCell>
                      <TableCell>{message.massages}</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="error"
                          onClick={() => handleDeleteMessage(message.id)}
                        >
                          מחיקה
                        </Button>

                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>

              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MessagesList;
